export function AboutMeText(props) {
  return (
    <div
      className={` ${props?.classnames ? props?.classnames : ''} text-xs leading-15px text-black`}
    >
      {props?.text}
    </div>
  );
}
